import { render, staticRenderFns } from "./CustomerFilter.vue?vue&type=template&id=bbad076e&"
import script from "./CustomerFilter.vue?vue&type=script&lang=js&"
export * from "./CustomerFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bbad076e')) {
      api.createRecord('bbad076e', component.options)
    } else {
      api.reload('bbad076e', component.options)
    }
    module.hot.accept("./CustomerFilter.vue?vue&type=template&id=bbad076e&", function () {
      api.rerender('bbad076e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/realEstate/components/CustomerFilter.vue"
export default component.exports